<template>
  <main class="main product-list-page product-page page-inside">
    <div class="main-wrapper">
      <section class="section hero-section">
        <div class="wrapper">
          <router-link to="/product-list" class="link hover-link desc">
            <img src="./../images/back.svg" class="img" />
            <span>{{ $t(`Back to Prompts`) }}</span>
          </router-link>
        </div>
      </section>
      <section class="section product-list-section">
        <img src="./../images/believe-peace.svg" class="img peace" />
        <div class="wrapper">
          <transition name="fade">
            <div class="product-preview" v-if="productPageItem">
              <div class="preview-container">
                <div class="preview-wrapper">
                  <div class="preview">
                    <img v-if="productPageItem && productPageItem.pack_id && productPageType != 'prompt'"
                      :src="imgDomain + activePack.image_url" class="img" />
                    <img v-if="productPageItem && (!productPageItem.pack_id || productPageType == 'prompt')"
                      :src="imgDomain + productPageItem.image_url" class="img" />
                  </div>
                </div>
              </div>
              <div class="text">
                <div class="text-wrapper">
                  <div class="title" v-if="productPageItem && productPageItem.pack_id && productPageType != 'prompt'">
                    {{ activePack.title }}</div>
                  <div class="title" v-if="productPageItem && (!productPageItem.pack_id || productPageType == 'prompt')">
                    {{ productPageItem.title }}</div>
                  <div class="tag">
                    <div class="desc">
                      <b>{{ $t(`Model:`) }}</b>
                    </div>
                    <div class="desc">{{ tag }}</div>
                  </div>
                  <div class="desc description">
                    <b>{{ $t(`Description:`) }}</b>
                    <div class="desc" v-if="productPageItem && productPageItem.pack_id && productPageType != 'prompt'"
                      v-html="activePack.description"></div>
                    <div class="desc" v-if="productPageItem && (!productPageItem.pack_id || productPageType == 'prompt')"
                      v-html="productPageItem.description"></div>
                  </div>
                  <div class="row-price">
                    <div class="desc">
                      <b>{{ $t(`Price:`) }}</b>
                    </div>
                    <div v-if="productPageItem && productPageItem.pack_id && productPageType != 'prompt'" class="title">{{
              activePack.price }} <span class="currency">{{ currency }}</span></div>
                    <div v-if="productPageItem && (!productPageItem.pack_id || productPageType == 'prompt')" class="title">{{
              productPageItem.price }} <span class="currency">{{ currency }}</span></div>
                    <button class="button green" @click="getPromt">
                      <span>{{ $t(`Get prompt`) }}</span>
                    </button>
                  </div>
                  <div class="spec-text">
                    <div class="desc" v-if="productPageItem && productPageItem.pack_id && productPageType != 'prompt'">
                      {{ $t(`After purchasing, you will gain access to the prompt file.`) }} <br />
                      <div>
                        {{ $t(`By purchasing this bundle, you agree to our `) }}
                        <a href="javascript:void(0);" @click="goToPage('terms')">{{ $t('terms of service')
                          }}</a>.
                      </div>
                    </div>
                    <div class="desc" v-if="productPageItem && (!productPageItem.pack_id || productPageType == 'prompt')">
                      {{ $t(`After purchasing, you will gain access to the prompt file.`) }} <br />
                      <div>
                        {{ $t(`By purchasing this prompt, you agree to our `) }}
                        <a href="javascript:void(0);" @click="goToPage('terms')">{{ $t('terms of service')
                          }}</a>.
                      </div>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </transition>
          <transition name="fade">
            <div class="list products"
              v-if="(productPageItem && productPageItem.pack_id && productPageType != 'prompt' && productList) || $route.params.type == 'pack'">
              <div class="item" v-for="(item, i) in productList" :key="i">
                <ProductCard :models="modelOptions" :tag="item.parent_cat_id" :item="item" :sliderIsClickble="true"
                  @goToProduct="goToProduct" :currency="currency" />
              </div>
              <div class="title no-products" v-if="!productList.length">{{ $t(`No products!`) }}</div>
            </div>
          </transition>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import { defineComponent } from 'vue';

import ProductCard from '../components/ProductCard.vue';
import { mapGetters } from "vuex";
export default defineComponent({
  emits: ['getProductPageContent', 'goToProduct'],
  name: 'ProductPage',
  props: ['currency', 'productPageItem'],
  inject: ['productPageItem', 'productPageType', 'imgDomain', 'openSignInModal', 'goToPage', 'openReadyModal'],

  components: {
    ProductCard
  },

  data: function () {
    return {
      tag: '',
      activePack: '',
      productList: [],
      modelOptions: [],
      imgDomain: ''
    }
  },

  watch: {
    '$route'(to, from) {
      // Watch for route changes to refetch product data when navigating between products
      if (to.params.id !== from.params.id || to.params.type !== from.params.type) {
        this.$emit('getProductPageContent', to.params.id, to.params.type);
      }
    },
    currency: function () {
      const id = this.$route.params.id;
      this.$emit('getProductPageContent', id);
    },
    productPageItem: function (newVal) {
      if (newVal) {
        this.getActivePack();
        this.$http.get('categories')
          .then((res) => {
            this.models = res.data.payload.filter(item => item.parent_id === null);
            let newTag = this.models.find(item => item.id === newVal.parent_cat_id)
            if (newTag) {
              this.tag = newTag['title'];
            }
          })
          .catch(() => {

          })
      }
    },
  },

  created() {

  },

  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
    
    // Fetch product data on initial load if not already available
    if (!this.productPageItem) {
      this.$emit('getProductPageContent', this.$route.params.id, this.$route.params.type);
    }
    
    this.getActivePack();
    this.getModels();
  },

  methods: {
    getModels() {
      this.$http.get('categories')
        .then((res) => {
          const newCategories = res.data.payload.filter(item => item.parent_id === null);
          // newCategories.unshift({name: 'All'});
          this.modelOptions = newCategories.map(({
            id: id,
            title: text,
            url: url
          }) => ({
            id,
            text,
            url
          }));
          this.modelOptions.unshift({ id: 0, text: 'All', url: '' })
        })
        .catch(() => {

        })
    },
    getActivePack() {
      if (this.$route.params.type == 'pack') {
        if (!this.productPageItem) {
          this.$emit('getProductPageContent', this.$route.params.id, this.$route.params.type);
          return;
        }
        this.$http.get('packs/' + this.productPageItem.id + '/info')
          .then((res) => {
            this.activePack = res.data.payload

            this.$http.get('packs/' + this.activePack.id)
              .then((res) => {
                this.productList = res.data.payload;
              })
              .catch(() => {

              })
          })
          .catch(() => {

          })
      } else {
        if (!this.productPageItem) {
          this.$emit('getProductPageContent', this.$route.params.id, this.$route.params.type);
        }
      }
    },
    getPromt() {
      if (this.isAuth) {
        this.openReadyModal();
      } else {
        this.openSignInModal();
      }
    },
    goToProduct(item) {
      this.$emit('goToProduct', item)
    }
  },

  computed: {
    ...mapGetters('user', ['isAuth'])
  },
});
</script>